import {
  LooksOneOutlined as Icon1,
  LooksTwoOutlined as Icon2,
  Looks3Outlined as Icon3,
  Looks4Outlined as Icon4,
  HelpOutline,
} from "@mui/icons-material";

const ICON_MAP = {
  // Sharing Types
  1: Icon1,
  2: Icon2,
  3: Icon3,
  4: Icon4,
};

export const SharingOutlinedIcon = ({ iconKey, ...props }) => {
  const IconComponent = ICON_MAP[iconKey] || HelpOutline;
  return <IconComponent fontSize="inherit" {...props} />;
};
